import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subject"]

  subjectTargetConnected(element: HTMLElement): void {
    this.subjectObserver.observe(element)
  }

  private scrollLinkIntoView(subjectId: string): void {
    document
      .querySelector(`[href="#${subjectId}"]`)
      ?.scrollIntoView({ block: "nearest", inline: "start" })
  }

  private get subjectObserver(): IntersectionObserver {
    return new window.IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          if (isIntersecting) {
            target.classList.add("--active")
            this.scrollLinkIntoView(target.id)
          } else {
            target.classList.remove("--active")
          }
        })
      },
      {
        root: null,
        rootMargin: "-25% 0px -75% 0px",
        threshold: 0
      }
    )
  }
}
